import { render, staticRenderFns } from "./Diagram.vue?vue&type=template&id=dde54ce8&scoped=true&"
import script from "./Diagram.vue?vue&type=script&lang=js&"
export * from "./Diagram.vue?vue&type=script&lang=js&"
import style0 from "./Diagram.vue?vue&type=style&index=0&id=dde54ce8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde54ce8",
  null
  
)

export default component.exports